<template>
    <div class="body center" ref="content">
        <input id="input_copy" style="position: absolute;top: -100rem;"/>
        <dom_content @go_to_scroll="go_to_scroll"></dom_content>
    </div>
</template>

<script>
var auto_height = require('../../vcomps/init_js/auto_height')

var dom_content = require('./modules/content')

module.exports = {
    components: {dom_content},

    data() {
        return {
            alter: false,
            size : 1,
        };
    },
    created() {
    },
    mounted() {
        var doms = [document.querySelector("body"), document.querySelector(".body")]
        var size = auto_height(doms, 750, 1080)
        this.size = size
    },


    methods: {
        close() {
            console.log('close')
            this.alter = !this.alter
        },
        click_type(type, value) {

        },

        go_to_scroll(top_px) {
            this.$refs.content.scrollTop = top_px / 100 * this.size
        },

    }
}
</script>
<style scoped>
.center {
    margin: auto;
    color: #ffffff;
}

/*!* TODO 打开*/
.body {
    /*overflow-x: auto;*/

    overflow-y: scroll;
    position: absolute;
    -webkit-overflow-scrolling: touch;
    height: 100vh;
}

.show_box_top {
    position: absolute;
    top: 0rem;
    left: 0rem;
}
</style>